// extracted by mini-css-extract-plugin
export default {"loading":"styles_loading__qmJNn","spin":"styles_spin__7RKWd","pulse":"styles_pulse__jkvOZ"};